import React, { Component } from 'react';
import { HISTORY } from "../../../utils/android_update_history.js";
import { Helmet } from "react-helmet";

import Support from '../Support';
import phone from './imgs/icon_android.svg';
import './Update.css';

class Android extends Component {

  render() {
    return (
      <div className="Android">
        <Helmet>
          <title>Android Update - Qbates</title>
          <meta name="description" content="Android App Update History" />
        </Helmet>
        <Support/>
        <div className="History">
          <h2>Update history</h2>
          <div className="List">
            <img src={phone} alt="android"/>
            {HISTORY.map((item, index) =>
              <div className="List-item" key={index}>
                <h4>Version {item.version} { index === 0 ? '( current )' : ''}</h4>
                <span>{item.date} updated</span>
                <ul>
                  {item.info.map((item, index) =>
                    <li key={index}>{item}</li>
                  )}
                </ul>
                <div className="prefix">
                  <div className="circle"/>
                  <div className="white"/>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Android;


// WEBPACK FOOTER //
// ./src/Containers/Support/components/Android.js